export type ViewportCommand = "fit" | "iso" | "top" | "front" | "right" | "left" | "back" | "bottom";

type Listener = (command: ViewportCommand) => void;
const listeners = new Set<Listener>();

export function sendViewportCommand(command: ViewportCommand): void {
  for (const listener of listeners) listener(command);
}

export function subscribeViewportCommands(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
